<template>
<div id="login">
    <div id="main">
        <div id="wrap login-wrap">
            <h1 class="logo-login">
                <a href="/">
                    <img src="../../assets/images/logo_login.png" alt="logo">
                </a>
            </h1>
            <div class="login-content-wrap">
                <div class="login-content">
                    <div class="input-login">
                        <!-- <input type="text" name="user_hp" v-on:input="autoHyphen" placeholder="휴대폰번호" v-bind:value="user_hp"> -->
                        <input type="text" name="user_m_account_id" placeholder="ID" v-model="user_m_account_id">                        
                        <input type="password" name="user_password" placeholder="Password" v-model="password">
                    </div>
                    <!-- 코드 추가 - 2020-12-21 -->
                    <div class="btn-register-wrap">
                        <div class="btn-autologin">
                            <input type="checkbox" name="check" v-model="autoLoginCheck">
                            <label for="check">자동로그인</label>
                        </div>
                        <div class="btn-register" @click="go_regist()">회원가입</div>
                        <div class="btn-register" @click="go_find_pw()">ID/PW 찾기</div>
                    </div>
                    <div class="btn-wrap">
                        <div class="btn-login" @click="do_login()"><span>확인</span></div>
                        <br><br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import * as config from '../../js/config';
import common from '../../js/common';
import EventBus from '../../js/event_bus';
import crypto from 'crypto-js';
export default {
    name: 'login',
    components: {},
    data() {
        return {
            user_m_account_id: '',
            password: '',
            autoLoginCheck: false
        }
    },
    mounted() {
        this.$nextTick(function () {
            // window.addEventListener('keyup', event => {                
            //     if(event.target.name == 'user_hp'){
            //         this.autoHyphen();
            //     }
            // })
        });

    },
    methods: {
        go_regist() {
            this.$router.push('/regist');
        },
        go_find_pw() {
            this.$router.push('/findpw');
        },
        autoHyphen(e) {
            this.user_hp = e.target.value;                
            var num = /^[0-9 \-]*$/;
            if (!num.test(this.user_hp)) {
                var str = this.user_hp;
                str = str.substr(0, str.length - 1);
                this.user_hp = str;                    
            }


            if (this.user_hp.length > 13) {
                this.user_hp = this.user_hp.substr(0, 13);
            } else {
                var val = this.user_hp.replace(/\D/g, '');
                var original = this.user_hp.replace(/\D/g, '').length;
                var conversion = '';
                for (let i = 0; i < 3; i++) {
                    if (val.length > 3 && i === 0) {
                        conversion += val.substr(0, 3) + '-';
                        val = val.substr(3);
                    } else if (original > 6 && val.length > 3 && i === 1) {
                        conversion += val.substr(0, 3) + '-';
                        val = val.substr(3);
                    } else if (original > 10 && val.length < 12 && i === 2) {
                        let value = this.user_hp.replace(/-/gi, "");
                        conversion = '';
                        this.user_hp = value.substring(0, 3) + '-' + value.substring(3, 7) + '-' + value.substring(7, 11);
                        return this.user_hp;
                    }
                }
                conversion += val;
                this.user_hp = conversion;
            }
        },
        async encrypt(pass){
          const encrypted = await crypto.AES.encrypt(pass, config.CRYPTO_KEY, {
            iv: config.CRYPTO_IV,
            mode: crypto.mode.CBC,
            padding: crypto.pad.Pkcs7
          })
          return encrypted.toString();

        },
        async do_login() {
            this.$store.commit('setLoading', { value: true});
            var data = {
                user_m_account_id: this.user_m_account_id,
                password: await this.encrypt(this.password)
            }
            var type = config.REQ_USER_LOGIN;
            common.getData(type, data,
                (response) => {
                    if (response.res_result) {
                        this.$store.commit('setUser_info', {
                            value: response.userInfo
                        });
                        this.$store.commit('setLogin_chk', {
                            value: true
                        });
                        this.$router.push('/');

                        if(this.autoLoginCheck){
                            common.autoLoginSetting(response.token);
                        }
                    } else {
                        //팝업
                        var data = {
                                code: 103,
                                message: 'ID 와 비밀번호를 다시한번 확인해 주세요.'
                        };
                        EventBus.$emit('popup-data', data);
                        console.log('로그인 실패 또는 아이디 미존재');
                    }
                })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/page/LoginPage.vue